<template>
    <div id="HomeLinkItem">
        <a-row>
            <a-col :span="4">
                <div class="image-icon">
                    <img :src="imgUrl" alt="">
                </div>
            </a-col>
            <a-col :span="18">
                <div class="item-title">{{item.title}}</div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    export default {
        name: "HomeLinkItem",
        props: ['item'],
        data() {
            return {
                imgUrl: require('../assets/image/bg_1.jpg')
            }
        },
        destroyed() {
        },
        created() {
        },
        methods: {}
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #HomeLinkItem {
        min-width: 480px;
        width: 100%;
        height: 80px;
    }

    .image-icon {
        width: 50px;
        height: 50px;
        border-radius: 25px;
        margin-top: 15px;
        overflow: hidden;
    }

    .item-title {
        margin-left: 10px;
        text-align: left;
        font-size: 28px;
        line-height: 40px;
        font-weight: 400;
        height: 80px;
        width: 100%;
        word-break:break-all;
        word-wrap:break-word;
        overflow: hidden;
        text-overflow:ellipsis;
        -o-text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

</style>
